import React, { useEffect, useState } from "react";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";

const ImagePreviewModal = ({ isOpen, onClose, imageUrl, isPdf }) => {
    const [blobUrl, setBlobUrl] = useState("");

    useEffect(() => {
        let objectUrl;

        const fetchFile = async () => {
            if (!imageUrl) return;
            const authUser = localStorage.getItem("authUser");
            const token = authUser.replace(/^"|"$/g, "");

            try {
                const response = await fetch(imageUrl, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });

                if (!response.ok) {
                    throw new Error("Failed to fetch file");
                }

                const blob = await response.blob();
                objectUrl = URL.createObjectURL(blob);

                setBlobUrl(objectUrl);
            } catch (error) {
                console.error("Error loading file:", error);
                onClose(); // optional: close modal on error
            }
        };

        if (isOpen) {
            fetchFile();
        }

        return () => {
            if (objectUrl) {
                URL.revokeObjectURL(objectUrl);
            }
        };
    }, [imageUrl, isOpen, onClose]);

    let isPdfAvailable = isPdf ? true : imageUrl?.toLowerCase().endsWith(".pdf");
    return (
        <Modal
            open={isOpen}
            onClose={onClose}
            aria-labelledby="document-preview-modal"
            aria-describedby="modal-to-preview-document"
            closeAfterTransition
            BackdropProps={{
                timeout: 500,
            }}
        >
            <Box
                sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    height: "100vh",
                    backgroundColor: "rgba(0, 0, 0, 0.75)",
                    outline: "none",
                    position: "relative",
                    padding: "20px",
                }}
            >
                <IconButton
                    onClick={onClose}
                    sx={{
                        position: "absolute",
                        top: { xs: 70, md: 10 },
                        right: 10,
                        color: "white",
                        zIndex: 1400,
                    }}
                >
                    <CloseIcon />
                </IconButton>

                {blobUrl ? (
                    isPdfAvailable ? (
                        <iframe
                            src={`${blobUrl}#toolbar=0`}
                            title="PDF Preview"
                            className="tw-rounded-2xl"
                            style={{
                                width: "80%",
                                height: "90%",
                                border: "none",
                            }}
                        />
                    ) : (
                        <img
                            src={blobUrl}
                            alt="Preview"
                            style={{
                                maxWidth: "100%",
                                maxHeight: "90vh",
                                objectFit: "contain",
                            }}
                        />
                    )
                ) : (
                    <p style={{ color: "white" }}>Loading...</p>
                )}
            </Box>
        </Modal>
    );
};

export default ImagePreviewModal;
